import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import AboutMed from '../../assets/images/about-medicine.png'
import Medi from '../../assets/images/medicines.png'

export default function news() {
  return (
    <>
      <Navbar/>
  <section className="about_section ">
    <div className="container">
      <div className="custom_heading-container ">
        <h2>
          News
        </h2>
      </div>

      <div className="img-box">
        <img src={AboutMed} alt=""/>
      </div>
      <div className="detail-box">
        <p>
          It is a long established fact that a reader will be distracted by the readable content of a page when looking
          at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
          opposed to using 'Content here, content here', making it
        </p>
        <div className="d-flex justify-content-center">
          <a href="#!">
            Read More
          </a>
        </div>
      </div>
    </div>
  </section>


  <section className="feature_section  layout_padding">
    <div className="container">
      <div className="feature_container">
        <div className="box">
          <div className="img-box">

          </div>
          <div className="detail-box">
            <h5>
              Fast Delivery
            </h5>
            <p>
              It is a long established fact that a reader will be distracted by
            </p>
          </div>
        </div>
        <div className="box">
          <div className="img-box">

          </div>
          <div className="detail-box">
            <h5>
              license of government
            </h5>
            <p>
              It is a long established fact that a reader will be distracted by
            </p>
          </div>
        </div>
        <div className="box">
          <div className="img-box">


          </div>
          <div className="detail-box">
            <h5>
              support24/7
            </h5>
            <p>
              It is a long established fact that a reader will be distracted by
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div className="layout_padding-bottom">


    <section className="discount_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 col-md-5 offset-md-2">
            <div className="detail-box">
              <h2>
                You get <br/>
                any medicine <br/>
                on
                <span>
                  10% discount
                </span>

              </h2>
              <p>
                It is a long established fact that a reader will be distracted by
              </p>
              <div>
                <Link to="/medici">
                  Buy Now
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-5">
            <div className="img-box">
              <img src={Medi} alt=""/>
            </div>
          </div>
        </div>
      </div>
    </section>

      </div>    
      <Footer/>
    </>
  )
}
